import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { HeaderAppearanceEvents } from '@unicup-ticketing/core';
import { Dispatcher } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-legal-notice',
  imports: [],
  templateUrl: './legal-notice.component.html',
  styleUrl: './legal-notice.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalNoticeComponent implements OnInit {
  private readonly dispatcher = inject(Dispatcher);

  ngOnInit(): void {
    this.dispatcher.dispatch(HeaderAppearanceEvents.requestUnhero());
  }
}
